/**
 * 防抖函数，可以控制是立即执行还是末次执行
 * @param {Function} fn 需要防抖的函数
 * @param {number} wait 等待时间（毫秒）
 * @param {boolean} immediate 是否立即执行，true为立即执行，false为末次执行
 * @returns {Function} 防抖后的函数
 */
export const debounce = (fn, wait = 300, immediate = true) => {
  let timer = null;
  let lastCallTime = 0;
  let lastArgs = null;
  let lastContext = null;
  let shouldExecute = false;

  return function (...args) {
    const context = this;
    const currentTime = Date.now();

    lastArgs = args;
    lastContext = context;
    shouldExecute = true;

    if (immediate) {
      // 立即执行模式
      // 如果是首次调用或者距离上次执行已经超过等待时间，则立即执行
      if (currentTime - lastCallTime > wait) {
        lastCallTime = currentTime;
        return fn.apply(context, args);
      }
    } else {
      // 末次执行模式
      if (timer) clearTimeout(timer);

      // 确保在wait时间内至少执行一次
      if (currentTime - lastCallTime > wait && shouldExecute) {
        lastCallTime = currentTime;
        shouldExecute = false;
        fn.apply(context, args);
      }

      timer = setTimeout(() => {
        if (shouldExecute) {
          lastCallTime = Date.now();
          fn.apply(lastContext, lastArgs);
        }
      }, wait);
    }
  };
};
